export const infrastructuresData = [
  {
    id: 1,
    title: "35944",
    geolocation: {
      latitude: 40.6352198,
      longitude: 22.9355045,
    },
    image: null,
    category: {
      id: 1,
      name: "\u03a1\u03ac\u03bc\u03c0\u03b5\u03c2",
    },
    type: {
      id: 2,
      name: "\u0394\u03b7\u03bc\u03cc\u03c3\u03b9\u03b1",
    },
  },
  {
    id: 2,
    title: "35945",
    geolocation: {
      latitude: 40.6352121,
      longitude: 22.9354896,
    },
    image: null,
    category: {
      id: 3,
      name: "\u03a0\u03b5\u03b6\u03bf\u03b4\u03c1\u03cc\u03bc\u03b9\u03b1 \u0391\u039c\u0395\u0391",
    },
    type: {
      id: 2,
      name: "\u0394\u03b7\u03bc\u03cc\u03c3\u03b9\u03b1",
    },
  },
  {
    id: 3,
    title: "35946",
    geolocation: {
      latitude: 40.6524485,
      longitude: 22.931053,
    },
    image: null,
    category: {
      id: 9,
      name: "\u0386\u03bb\u03bb\u03bf",
    },
    type: {
      id: 2,
      name: "\u0394\u03b7\u03bc\u03cc\u03c3\u03b9\u03b1",
    },
  },
  {
    id: 4,
    title: "35947",
    geolocation: {
      latitude: 40.6528552,
      longitude: 22.9308595,
    },
    image: null,
    category: {
      id: 9,
      name: "\u0386\u03bb\u03bb\u03bf",
    },
    type: {
      id: 2,
      name: "\u0394\u03b7\u03bc\u03cc\u03c3\u03b9\u03b1",
    },
  },
  {
    id: 5,
    title: "35948",
    geolocation: {
      latitude: 40.6533625,
      longitude: 22.9306081,
    },
    image: null,
    category: {
      id: 9,
      name: "\u0386\u03bb\u03bb\u03bf",
    },
    type: {
      id: 2,
      name: "\u0394\u03b7\u03bc\u03cc\u03c3\u03b9\u03b1",
    },
  },
  {
    id: 6,
    title: "35949",
    geolocation: {
      latitude: 40.6533945,
      longitude: 22.9305496,
    },
    image: null,
    category: {
      id: 9,
      name: "\u0386\u03bb\u03bb\u03bf",
    },
    type: {
      id: 2,
      name: "\u0394\u03b7\u03bc\u03cc\u03c3\u03b9\u03b1",
    },
  },
  {
    id: 7,
    title: "35950",
    geolocation: {
      latitude: 40.6538211,
      longitude: 22.9300353,
    },
    image: null,
    category: {
      id: 9,
      name: "\u0386\u03bb\u03bb\u03bf",
    },
    type: {
      id: 2,
      name: "\u0394\u03b7\u03bc\u03cc\u03c3\u03b9\u03b1",
    },
  },
  {
    id: 8,
    title: "35951",
    geolocation: {
      latitude: 40.6538672,
      longitude: 22.929941,
    },
    image: null,
    category: {
      id: 9,
      name: "\u0386\u03bb\u03bb\u03bf",
    },
    type: {
      id: 2,
      name: "\u0394\u03b7\u03bc\u03cc\u03c3\u03b9\u03b1",
    },
  },
  {
    id: 9,
    title: "35952",
    geolocation: {
      latitude: 40.6537141,
      longitude: 22.9298824,
    },
    image: null,
    category: {
      id: 9,
      name: "\u0386\u03bb\u03bb\u03bf",
    },
    type: {
      id: 4,
      name: "\u0399\u03b4\u03b9\u03c9\u03c4\u03b9\u03ba\u03ae",
    },
  },
  {
    id: 15,
    title: "35958",
    geolocation: {
      latitude: 40.6530116,
      longitude: 22.9289488,
    },
    image: null,
    category: {
      id: 9,
      name: "\u0386\u03bb\u03bb\u03bf",
    },
    type: {
      id: 2,
      name: "\u0394\u03b7\u03bc\u03cc\u03c3\u03b9\u03b1",
    },
  },
  {
    id: 31,
    title: "35974",
    geolocation: {
      latitude: 40.6527793,
      longitude: 22.9296652,
    },
    image: null,
    category: {
      id: 3,
      name: "\u03a0\u03b5\u03b6\u03bf\u03b4\u03c1\u03cc\u03bc\u03b9\u03b1 \u0391\u039c\u0395\u0391",
    },
    type: {
      id: 2,
      name: "\u0394\u03b7\u03bc\u03cc\u03c3\u03b9\u03b1",
    },
  },
  {
    id: 16,
    title: "35959",
    geolocation: {
      latitude: 40.6529496,
      longitude: 22.9293622,
    },
    image: null,
    category: {
      id: 3,
      name: "\u03a0\u03b5\u03b6\u03bf\u03b4\u03c1\u03cc\u03bc\u03b9\u03b1 \u0391\u039c\u0395\u0391",
    },
    type: {
      id: 2,
      name: "\u0394\u03b7\u03bc\u03cc\u03c3\u03b9\u03b1",
    },
  },
  {
    id: 17,
    title: "35960",
    geolocation: {
      latitude: 40.6529496,
      longitude: 22.9293622,
    },
    image: null,
    category: {
      id: 3,
      name: "\u03a0\u03b5\u03b6\u03bf\u03b4\u03c1\u03cc\u03bc\u03b9\u03b1 \u0391\u039c\u0395\u0391",
    },
    type: {
      id: 2,
      name: "\u0394\u03b7\u03bc\u03cc\u03c3\u03b9\u03b1",
    },
  },
  {
    id: 18,
    title: "35961",
    geolocation: {
      latitude: 40.6531199,
      longitude: 22.9290779,
    },
    image: null,
    category: {
      id: 1,
      name: "\u03a1\u03ac\u03bc\u03c0\u03b5\u03c2",
    },
    type: {
      id: 2,
      name: "\u0394\u03b7\u03bc\u03cc\u03c3\u03b9\u03b1",
    },
  },
  {
    id: 19,
    title: "35962",
    geolocation: {
      latitude: 40.6530366,
      longitude: 22.9291694,
    },
    image: null,
    category: {
      id: 1,
      name: "\u03a1\u03ac\u03bc\u03c0\u03b5\u03c2",
    },
    type: {
      id: 2,
      name: "\u0394\u03b7\u03bc\u03cc\u03c3\u03b9\u03b1",
    },
  },
  {
    id: 20,
    title: "35963",
    geolocation: {
      latitude: 40.6529639,
      longitude: 22.9292261,
    },
    image: null,
    category: {
      id: 1,
      name: "\u03a1\u03ac\u03bc\u03c0\u03b5\u03c2",
    },
    type: {
      id: 2,
      name: "\u0394\u03b7\u03bc\u03cc\u03c3\u03b9\u03b1",
    },
  },
];

export const infrastructureCategoryFilters = [
  { typeId: "1", type: "category", name: "Ράμπες", isActive: true },
  { typeId: "3", type: "category", name: "Πεζοδρόμια ΑΜΕΑ", isActive: true },
  { typeId: "5", type: "category", name: "Αποδητήρια ΑΜΕΑ", isActive: true },
  { typeId: "6", type: "category", name: "Διάβαση τυφλών", isActive: true },
  { typeId: "7", type: "category", name: "Φανάρι με ήχο", isActive: true },
  {
    typeId: "8",
    type: "category",
    name: "Ανελκυστήρες ΑΜΕΑ",
    isActive: true,
  },
  { typeId: "9", type: "category", name: "Άλλο", isActive: true },
];

export const infrastructureTypeFilters = [
  { typeId: "2", type: "type", name: "Δημόσια", isActive: true },
  { typeId: "4", type: "type", name: "Ιδιωτική", isActive: true },
];

export const getCategoryInfos = (categoryId) => {
  switch (categoryId) {
    case "1":
      return {
        title: "Περιβαλλοντικά Δεδομένα",
        tooltip: "Δεδομένα που αφορούν τις περιβαλλοντικες συνθήκες",
        bgColor: "#33D553",
        icon: "im-icon-Globe",
        mapContent: ["title", "dataIcons"],
        size: "large",
        mapOnTile: false,
      };
    case "2":
      return {
        title: "Συνάθροιση Κοινού",
        tooltip:
          "Αριθμητικά δεδομένα που αφορούν την συνάθροιση των δημοτών σε συγκεκριμένα σημεία της πόλης.",
        mapTitle: "Δεδομένα Συνάθροισης Κοινού",
        bgColor: "#FB5606",
        icon: "im-icon-Business-Mens",
        mapContent: ["title", "dataIcons"], // ["address", "neighborhood", "dataIcons"],
        size: "normal", // large: 280 x 560, normal: 280 x 275,
        mapOnTile: false,
      };
    case "4":
      return {
        title: "WiFi Hotspots",
        tooltip:
          "Σημεία δωρεάν και ελεύθερης πρόσβασης στο διαδίκτυο μέσω WiFi",
        bgColor: "#FF006E",
        icon: "im-icon-Wifi",
        mapContent: ["name", "address"],
        size: "large", // large: 280 x 560, normal: 280 x 275
        mapOnTile: true,
      };
    case "5":
      return {
        title: "Μετεωρολογικά Δεδομένα",
        tooltip: "Δείτε απευθείας τα μετεωρολογικά δεδομένα της περιοχής μας",
        bgColor: "#FFBE0A",
        icon: "im-icon-Cloud-Sun",
        mapContent: ["title", "dataIcons"],
        size: "large", // large: 280 x 560, normal: 280 x 275
        mapOnTile: false,
      };
    case "6":
      return {
        title: "Ποιότητα Υδάτων",
        tooltip:
          "Δεδομένα που αφορούν την ποιότητα του νερού (ph, οξυγόνο κλπ.)",
        mapTitle: "Δεδομένα Ποιότητας Υδάτων",
        bgColor: "#00A1FF",
        icon: "im-icon-Drop",
        mapContent: ["title", "name", "dataIcons"],
        size: "normal", // large: 280 x 560, normal: 280 x 275
        mapOnTile: false,
      };
    case "7":
      return {
        title: "Σημεία ενδιαφέροντος",
        tooltip: "",
        bgColor: "#CB6DE9",
        icon: "im-icon-Map-Marker",
        mapContent: ["name", "address"],
        size: "normal",
        mapOnTile: true,
      };
    case "8":
      return {
        title: "Διαχ/ση Στόλου",
        tooltip:
          "Δείτε την τοποθεσία του στόλου των απορριματοφόρων για την αποκομιδή των σκουπιδιών",
        mapTitle: "Δρομολόγια Απορριμματοφόρων",
        bgColor: "#FF8700",
        icon: "im-icon-Truck",
        mapContent: ["title", "category"],
        size: "large",
        mapOnTile: true,
      };
    case "9":
      return {
        title: "Κάδοι",
        tooltip: "Δείτε σε πραγματικό χρόνο την πληρότητα κάδων",
        mapTitle: "Πληρότητα κάδων",
        bgColor: "#179D00",
        icon: "im-icon-Recycling", // dynamic icon
        mapContent: ["address", "binLevel"],
        size: "large",
        mapOnTile: true,
      };
    case "10":
      return {
        title: "Υδρόμετρα",
        tooltip:
          "Δεδομένα που αφορούν την κατανάλωση νερού σε επιλεγμένες παροχές",
        mapTitle: "",
        bgColor: "#357BEB",
        icon: "im-icon-Gaugage",
        mapContent: ["type", "timestamp"],
        size: "large",
        mapOnTile: true,
      };
    case "11":
      return {
        title: "Αστική κινητικότητα",
        tooltip: "Αισθητήρες κίνησης στους δρόμους",
        bgColor: "#6E93FF",
        icon: "im-icon-Satelite",
        mapContent: ["address", "sensor"],
        size: "large",
        mapOnTile: false,
      };
    case "12":
      return {
        title: "Κατανάλωση ενέργειας",
        tooltip: "Κατανάλωση τελευταίας ώρας",
        mapTitle: "",
        bgColor: "#CB6DE9",
        mapBgColor: "",
        icon: "im-icon-On-Off-3",
        mapContent: ["name", "city", "dataIcons"],
        size: "large",
        mapOnTile: false,
      };
    case "13":
      return {
        title: "Ζύγιση Απορριμμάτων",
        tooltip: "Αποκομιδή απορριμάτων",
        bgColor: "#18D786",
        icon: "im-icon-Mine",
        mapContent: [],
        size: "large",
        mapOnTile: true,
      };
    case "24":
      return {
        title: "Θέσεις Στάθμευσης",
        tooltip: "Ελεύθερες θέσεις για το PARKING",
        mapTitle: "Αισθητήρες στάθμευσης",
        bgColor: "#CB6DE9",
        icon: "im-icon-Car-2", // ο δήμος Πέλλας έχει το εικονίδιο
        mapContent: ["address", "plirotita"],
        size: "normal",
        mapOnTile: false,
      };
    case "28":
      return {
        title: "Δεξαμενή",
        tooltip: "Δεδομένα που αφορούν την κατάσταση των δεξαμενών νερού",
        mapTitle: "Στάθμη Δεξαμενής",
        bgColor: "#CB6DE9",
        mapBgColor: "",
        icon: "",
        mapContent: ["title", "name", "dataIcons"],
        size: "large",
        mapOnTile: true,
      };
    case "29":
      return {
        title: "Ηλεκτροφορτιστές",
        // tooltip: "",
        bgColor: "#CB6DE9",
        mapBgColor: "",
        icon: "im-icon-Power-Cable",
        mapContent: ["title"],
        size: "large",
        mapOnTile: true,
      };
    case "30":
      return {
        title: "Έξυπνα παγκάκια",
        // tooltip: "",
        bgColor: "#A9DE31",
        icon: "im-icon-Battery-Charge",
        mapContent: ["address", "address"],
        size: "large",
        mapOnTile: true,
      };
    case "31":
      return {
        title: "Πινακίδες πληροφόρησης", //ηλιακοί φορτιστες
        // tooltip: "",
        bgColor: "#DE31A9",
        icon: "im-icon-Monitor-Vertical",
        mapContent: ["address", "address"],
        size: "large",
        mapOnTile: true,
      };
    case "32":
      return {
        title: "Έξυπνες διαβάσεις",
        // tooltip: "",
        bgColor: "#31A9DE",
        icon: "im-icon-Traffic-Light2",
        mapContent: ["address", "address"],
        size: "large",
        mapOnTile: true,
      };
    case "33":
      return {
        title: "Παρκόμετρα",
        // tooltip: "",
        bgColor: "#8c6de8",
        icon: "im-icon-Timer-2",
        mapContent: ["title"],
        size: "large",
        mapOnTile: true,
      };
    case "34":
      return {
        title: "Κολωνάκια",
        // tooltip: "",
        bgColor: "#065DFB",
        icon: "im-icon-Button",
        mapContent: ["address"], // prefix: Κολωνάκι
        size: "large",
        mapOnTile: true,
      };
    case "122a":
      return {
        header: {
          title: "Διαδρομές ΑΜΕΑ",

          bgColor: "#27AAE1",
        },
        content: {
          items: {
            routes: ["name", "type"],
            infra: [["category", "title"], "type"],
          },
          icon: "im-icon-Truck",
        },
        map: {
          title: "ΑΜΕΑ", // prefix ==> routes: "διαδρομές", infra: "Υποδομές"
          bgColor: "#27AAE1",
          ItemContent: {
            routes: ["name", "type"],
            infra: [["category", "title"], "type"],
          },
        },
      };
    case "122":
      return {
        title: "Υποδομές ΑΜΕΑ",
        // tooltip: "",
        mapTitle: "ΑΜΕΑ", // prefix ==> routes: "διαδρομές", infra: "Υποδομές"
        bgColor: "#27AAE1",
        icon: "im-icon-Truck",
        mapContent: {
          routes: ["name", "type"],
          infra: [["category", "title"], "type"],
        },
        size: "large",
        mapOnTile: true,
      };
    default:
      return null;
  }
};

export const activeData = {
  states: [
    "meteo",
    "info",
    "infra",
    "routes",
    "weather",
    "indexes",
    "all",
    "AmeaFilters",
    "sensorTypes",
    "newRouteData",
    "auth",
    "amea",
    "routesCategories",
  ],
  maps: ["meteo", "info", "amea"],
};

export const cityCenters = [
  {
    city: "amplelokipoi",
    location: {
      lat: 40.653582,
      lng: 22.922504,
    },
  },
];

export const citySensorTypes = [
  {
    sensortype_id: "1",
    sensortype_name: "Περιβαλλοντικά Δεδομένα",
    temp_name: "envi",
  },
  {
    sensortype_id: "2",
    sensortype_name: "Δεδομένα Συνάθροισης Κοινού",
    temp_name: "gathering",
  },
  {
    sensortype_id: "4",
    sensortype_name: "WiFi Hotspots",
    temp_name: "wifi",
  },
  {
    sensortype_id: "5",
    sensortype_name: "Μετεωρολογικά Δεδομένα",
    temp_name: "meteo",
  },
  {
    sensortype_id: "24",
    sensortype_name: "Αισθητήρες στάθμευσης",
    temp_name: "parking",
  },
  {
    sensortype_id: "30",
    sensortype_name: "Έξυπνα παγκάκια",
    temp_name: "benches",
  },
  {
    sensortype_id: "31",
    sensortype_name: "Πινακίδες πληροφόρησης",
    temp_name: "info",
  },
  {
    sensortype_id: "32",
    sensortype_name: "Έξυπνες διαβάσεις",
    temp_name: "crossing",
  },
  {
    sensortype_id: "36",
    sensortype_name: "Δημόσια χώροι στάθμευσης",
    temp_name: "publicParking",
  },
  {
    sensortype_id: "122",
    sensortype_name: "Υποδομές ΑΜΕΑ",
    temp_name: "amea",
  },
];

export const StepsColumns = [
  {
    title: "Icon",
    dataIndex: "icon",
    key: "icon",
    width: "60px",
  },
  {
    title: "Infrastructure",
    dataIndex: "infrastructure",
    key: "infrastructure",
    width: "300px",
  },
  {
    title: "Action",
    dataIndex: "action",
    key: "action",
  },
];

export const handleLogin = () => {
  const isDEV = window.location.href.includes("localhost");
  const params = new URLSearchParams({
    client_id: isDEV
      ? process.env.REACT_APP_DEV_CLIENT_ID
      : process.env.REACT_APP_PROD_CLIENT_ID,
    redirect_uri: isDEV
      ? process.env.REACT_APP_DEV_REDIRECT_URI
      : process.env.REACT_APP_PROD_REDIRECT_URI,
    scope: "citizen",
    response_type: "code",
  });
  window.location.href = `${process.env.REACT_APP_BASE_URL}/oauth/authorize?${params}`;
};

export const handleLogout = (token) => {
  const isDEV = window.location.href.includes("localhost");
  const params = new URLSearchParams({
    redirect_uri: isDEV
      ? process.env.REACT_APP_DEV_REDIRECT_URI
      : process.env.REACT_APP_PROD_REDIRECT_URI,
    access_token: token,
  });
  localStorage.removeItem("user");
  localStorage.setItem(
    "url",
    `${process.env.REACT_APP_BASE_URL}/api/users/logout?${params}`
  );

  window.location.href = `${process.env.REACT_APP_BASE_URL}/api/users/logout?${params}`;
};

export const inputValidation = (inputType, value, initialValue) => {
  const getInputName = (input) => {
    switch (input) {
      case "name":
        return "όνομα";
      case "surname":
        return "επώνυμο";
      case "address":
        return "διεύθυνση";
      default:
        return "";
    }
  };

  let valid = true;
  let errorMessage = null;
  switch (inputType) {
    case "name":
    case "surname":
    case "address":
      if (value.length < 3) {
        valid = false;
        errorMessage = `Το ${getInputName(
          inputType
        )} πρέπει να έχει περισσότερους από 3 χαρακτήρες`;
      } else if (!/^[A-Za-zΑ-Ωα-ωίϊΐόάέύϋΰήώ0-9\s]+$/.test(value)) {
        valid = false;
        errorMessage = `Το ${getInputName(
          inputType
        )} μπορεί να περιέχει μόνο γράμματα, αριθμούς`;
      } else {
        valid = true;
        errorMessage = null;
      }
      break;
    case "email":
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (!emailRegex.test(value)) {
        valid = false;
        errorMessage = "Το Email δεν είναι σωστό";
      } else {
        valid = true;
        errorMessage = null;
      }
      break;
    case "password":
      if (value.length < 8) {
        valid = false;
        errorMessage = "Ο Κωδικός πρέπει να έχει τουλάχιστον 8 χαρακτήρες";
      } else if (!/(?=.*[a-z])/.test(value)) {
        valid = false;
        errorMessage = "Ο Κωδικός πρέπει να έχει τουλάχιστον 1 πεζό χαρακτήρα";
      } else if (!/(?=.*[A-Z])/.test(value)) {
        valid = false;
        errorMessage =
          "Ο Κωδικός πρέπει να έχει τουλάχιστον 1 κεφαλαίο χαρακτήρα";
      } else if (!/(?=.*\d)/.test(value)) {
        valid = false;
        errorMessage = "Ο Κωδικός πρέπει να έχει τουλάχιστον 1 αριθμό";
      } else {
        valid = true;
        errorMessage = null;
      }
      break;
    case "verifyPassword":
      if (!value) {
        valid = false;
        errorMessage = "Επιβεβαιώστε τον Κωδικό";
      } else if (value !== initialValue) {
        valid = false;
        errorMessage = "Οι κωδικοί δεν ταιριάζουν";
      } else {
        valid = true;
        errorMessage = null;
      }

      break;
    default:
      break;
  }
  return errorMessage;
  // return {
  //   valid,
  //   errorMessage,
  // };
};
